'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _user = _interopRequireDefault(require("./../user/user"));

var _userStatus = _interopRequireDefault(require("../user-status"));

var _deleteButton = _interopRequireDefault(require("../delete-button"));

var _clipboardButton = _interopRequireDefault(require("../clipboard-button"));

var _translate = _interopRequireDefault(require("../translate"));

var _conf = _interopRequireDefault(require("../../conf"));

var _authorisation = _interopRequireDefault(require("../authorisation"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _userState = _interopRequireDefault(require("../user-state"));

var _farmComment = _interopRequireDefault(require("../farm-comment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DeleteButtonAuthorised = new _authorisation.default(['admin'], [], false)(_deleteButton.default);
var ClipboardButtonAuthorised = new _authorisation.default(['admin'], [], false)(_clipboardButton.default);

var UserView = /*#__PURE__*/function (_React$Component) {
  _inherits(UserView, _React$Component);

  function UserView(props) {
    var _this;

    _classCallCheck(this, UserView);

    _this = _possibleConstructorReturn(this, (UserView.__proto__ || Object.getPrototypeOf(UserView)).call(this, props));
    _this.state = {
      subMenuConfig: [{
        label: props.t('status'),
        anchor: 'status'
      }, {
        label: props.t('User'),
        anchor: 'user-data'
      }, {
        label: props.t('farm'),
        anchor: 'farm-status'
      }, {
        label: props.t('Projects'),
        anchor: 'project-status'
      }],
      userId: 0,
      user: null,
      projects: null
    };

    if (props.getSubMenuConfig) {
      props.getSubMenuConfig(_this.state.subMenuConfig);
    }

    return _this;
  }
  /**
   * @todo now we have to load a user in two different components (maybe?) how about do it here?
   *
   */


  _createClass(UserView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      fetch("".concat(_conf.default.api.userApiUrlTemplate(this.props.i18n.language), "/").concat(this.props.match.params.userId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (user) {
        _this2.setState({
          user: user,
          userId: user.id
        });
      }).catch(function (err) {
        void 0;

        if (err.error.status === 404) {
          _this2.props.history.push('/not-found');
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.user) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
          className: "loader loader--medium"
        }));
      }

      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "detail-view"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "title"
      }, t('detail view'), /*#__PURE__*/_react.default.createElement("span", {
        className: "icon-list"
      }, /*#__PURE__*/_react.default.createElement(DeleteButtonAuthorised, {
        history: this.props.history,
        id: parseInt(this.props.match.params.userId),
        url: _conf.default.api.userSingleApiUrlTemplate,
        language: this.props.i18n.language,
        label: t('delete user'),
        labelCancel: t('cancel'),
        labelSuccess: t('user was deleted'),
        labelDeleteFailed: t('user could not be deleted'),
        labelConfirmed: t('user was deleted'),
        labelConfirmation: t('do you really want to delete this user?' + ' The related farm and project registrations will be deleted too!'),
        labelConfirmButton: t('delete user'),
        pathNext1: '/',
        labelNext1: t('To dashboard'),
        pathNext2: '/users',
        labelNext2: t('to the user list')
      }), /*#__PURE__*/_react.default.createElement(ClipboardButtonAuthorised, {
        userId: this.props.match.params.userId
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x space-4"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, /*#__PURE__*/_react.default.createElement(_userState.default, {
        t: this.props.t,
        i18n: this.props.i18n,
        userId: this.props.match.params.userId,
        userData: this.state.user
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-10 large-9 xlarge-8"
      }, this.state.user && this.state.user.farm_id !== 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "space-3"
      }, /*#__PURE__*/_react.default.createElement(_farmComment.default, {
        id: parseInt(this.state.user.farm_id)
      })), /*#__PURE__*/_react.default.createElement(_user.default, {
        userId: this.props.match.params.userId,
        user: this.state.user
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-10 large-9 xlarge-8"
      }, /*#__PURE__*/_react.default.createElement(_userStatus.default, {
        userId: parseInt(this.props.match.params.userId),
        history: this.props.history
      }))));
    }
  }]);

  return UserView;
}(_react.default.Component);

UserView.propTypes = {
  history: _propTypes.default.object.isRequired,
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  match: _propTypes.default.shape({
    params: _propTypes.default.shape({
      userId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
    })
  }),
  getSubMenuConfig: _propTypes.default.func
};

var _default = (0, _translate.default)(UserView);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/user-view/index.js
// module id = 739
// module chunks = 0